import type { IPaginatedReponse } from "../types/api";

export const getPageCountFromMeta = (meta?: IPaginatedReponse<any>["meta"]) =>
  meta ? Math.ceil(meta.total / meta.perPage) : 1;
